// @flow

import { fragments as embroideryOrderStatusFragments } from "../../application/apps/EmbroideryApp/components/EmbroideryOrderStatus/graph";
import { gql } from "@apollo/client";
import { graphql } from '@apollo/client/react/hoc';

const markOrderAsEmbroideryCompleted: any = graphql(
  gql`
    mutation($orderId: ID!) {
      markOrderAsEmbroideryCompleted(orderId: $orderId) {
        errors {
          orderId
        }
        order {
          ...EmbroideryOrderStatus_order
        }
        succeeded
      }
    }
    ${embroideryOrderStatusFragments.order}
  `,
  {
    name: "markOrderAsEmbroideryCompleted"
  }
);

export default markOrderAsEmbroideryCompleted;
